import { c as _c } from "react/compiler-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import classNames from 'classnames';
import { Icon } from '../../components/Icon';
import { DefaultLink } from '../shared';
import commonStyles from '../shared/styles.module.css';
import styles from './UserInfo.module.css';
export type UserLoginLinkProps = {
  text: {
    loginUrl: string;
    label: string;
  };
  Link?: React.FC<any>;
};
function UserLoginLink(t0) {
  const $ = _c(9);
  const {
    text,
    Link: t1
  } = t0;
  const Link = t1 === undefined ? DefaultLink : t1;
  const t2 = text.loginUrl;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = classNames(commonStyles.navigationLink, styles.trigger, styles.loginLink);
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon name="user" color="fg-content-primary" className={styles.icon} size="400" />;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== text.label) {
    t5 = <span className={styles.label}>{text.label}</span>;
    $[2] = text.label;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== Link || $[5] !== t5 || $[6] !== text.label || $[7] !== text.loginUrl) {
    t6 = <div className={styles.login}><Link href={t2} className={t3} title={text.label} aria-label={text.label} prefetch={false}>{t4}{t5}</Link></div>;
    $[4] = Link;
    $[5] = t5;
    $[6] = text.label;
    $[7] = text.loginUrl;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}
export default UserLoginLink;